document.addEventListener("DOMContentLoaded", function () {
  $(".gallery-link")
    .addClass("selected")
    .parents(".dropdown")
    .find(".top-level-link")
    .addClass("selected");

  // glightbox custom markup for lightboxHTML
  const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container" data-taborder="-1">
    <div id="announcement-open" class="sr-only" aria-live="polite"></div>
    <div class="gloader visible"></div>
    <div class="goverlay"></div>
    <div class="gcontainer">
        <h2 class="sr-only">Larger View of Selected Photo</h2>
        <div id="glightbox-slider" class="gslider"></div>
        <button class="gnext gbtn" data-taborder="1" aria-label="Next photo">{nextSVG}</button>
        <button class="gprev gbtn" data-taborder="2" aria-label="Previous photo">{prevSVG}</button>
        <button class="gclose gbtn" data-taborder="3" aria-label="Close larger view">{closeSVG}</button>
    </div>
</div>`;

  // glightbox custom markup for customSlideHTML
  const customSlideHTML = `<div class="gslide">
    <div class="gslide-inner-content">
        <div class="ginner-container">
            <div class="gslide-media" aria-hidden="true">
            </div>
            <div class="gslide-description">
                <div class="gdesc-inner">
                    <div class="sr-only">
                        <h3 class="gslide-title"></h3>
                    </div>
                    <div class="gslide-desc"></div>
                </div>
            </div>
        </div>
    </div>
</div>`;

  const lightbox = GLightbox({
    lightboxHTML: customLightboxHTML,
    slideHTML: customSlideHTML,
  });

  // Pass a message into aria-live when modal is opened
  lightbox.on("open", () => {
    setTimeout(() => {
      document.getElementById("announcement-open").textContent =
        "Larger view open";
    }, 500);
  });
});
